﻿export class WorkItemNotAvailableForTransfer {
}